import {LiveStreamingModuleController} from "../live-streaming-module.controller";
import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";

export class LiveStreamingModuleProps extends BaseModuleProps {
  controller: LiveStreamingModuleController;
}
